const convertRoiGateFormDataToGoogleSheetFormData = require("./convertRoiGateFormDataToGoogleSheetFormData");
const submitFormToGoogleSheets = require(".././googleSheet/submitFormToGoogleSheets");
const sendRoiGateFormSubmissionStartedEmailToFormsAtIterableCom = require("./sendRoiGateFormSubmissionStartedEmailToFormsAtIterableCom");

/**
 * @param roiGateFormData {RoiGateFormData}
 * @return {Promise<void>}
 */
module.exports = async function logRoiGateFormSubmissionStart(roiGateFormData) {
    try {
        const googleSheetFormData = convertRoiGateFormDataToGoogleSheetFormData(roiGateFormData, "SUBMISSION_SUBMIT_BUTTON_CLICK");
        void submitFormToGoogleSheets(googleSheetFormData);

        void sendRoiGateFormSubmissionStartedEmailToFormsAtIterableCom(roiGateFormData);
    } catch (e) {
        // Failsafe
    }
}